import { FirebaseOptions, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getBlob, getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { InputFile } from "src/components/Form/upload-input";
import { Attachment } from "src/types";
// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
};

// Check if Firebase configuration is properly set
const requiredEnvVars = [
  "REACT_APP_API_KEY",
  "REACT_APP_AUTH_DOMAIN",
  "REACT_APP_PROJECT_ID",
  "REACT_APP_STORAGE_BUCKET",
  "REACT_APP_MESSAGING_SENDER_ID",
  "REACT_APP_APP_ID",
];

const missingVars = requiredEnvVars.filter((varName) => !process.env[varName]);
if (missingVars.length > 0) {
  console.error("Missing Firebase environment variables:", missingVars);
}

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});
export const auth = getAuth(app);
export const storage = getStorage(app);
export const InvoiceStorage = getStorage(app, process.env.REACT_APP_INVOICE_STORAGE_BUCKET);
export const functions = getFunctions(app,"europe-west1");

export const downloadFileByUrl = async (url: string) => {
  const content = await getBlob(ref(storage, url));
  return content;
};

export const uploadFilesToFirebase = async (mediaFiles: Array<InputFile>, path: string): Promise<Attachment[]> => {
  console.log("Uploading files to Firebase Storage...");

  // Use Promise.all to handle all uploads concurrently
  const uploadPromises = mediaFiles.map(async (mediaFile) => {
    // Create a unique file path for each upload
    const filePath = `${path}/${Date.now()}-${mediaFile.name}`;
    const storageRef = ref(storage, filePath);

    // Upload the file to Firebase Storage
    const snapshot = await uploadBytes(storageRef, mediaFile.file);

    // Get the download URL of the uploaded file
    const downloadUrl = await getDownloadURL(snapshot.ref);

    // Return the new Attachment object
    return {
      fileName: mediaFile.name,
      fileSizeInKB: Math.round(mediaFile.size / 1024).toString(),
      fileType: mediaFile.type === "image" ? "IMAGE" : "VIDEO",
      fileUrl: downloadUrl,
    } as Attachment;
  });

  // Wait for all promises to resolve
  const uploadedAttachments: Attachment[] = await Promise.all(uploadPromises);

  return uploadedAttachments;
};
